export default {"src":"/_next/static/media/home_location_pin.3e0c1ffe.svg","height":161,"width":258,"blurWidth":0,"blurHeight":0};